import { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';

const OBJ = { human: 'Žmonės', car: 'Automobiliai', bike: 'Dviračiai', bus: 'Autobusai', truck: 'Sunkvežimiai' };
const EMPTY = { name: '', camera_id: '', object_type: 'human', threshold: '', period_minutes: '60', notify_email: '', is_active: true };

export default function Alerts() {
  const [alerts,  setAlerts]  = useState([]);
  const [cameras, setCameras] = useState([]);
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState(EMPTY);
  const [editId,  setEditId]  = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
    api.get('/cameras').then(r => setCameras(r.data)).catch(() => {});
  }, []);

  async function loadData() {
    const r = await api.get('/alerts');
    setAlerts(r.data);
  }

  function openCreate() { setEditId(null); setForm(EMPTY); setModal(true); }
  function openEdit(a)   { setEditId(a.id); setForm({...a, is_active: !!a.is_active}); setModal(true); }

  async function handleSave(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editId) await api.put(`/alerts/${editId}`, form);
      else        await api.post('/alerts', form);
      toast.success(editId ? 'Atnaujinta' : 'Sukurta');
      setModal(false); loadData();
    } catch(err) { toast.error(err.response?.data?.error || 'Klaida'); }
    finally { setLoading(false); }
  }

  async function handleDelete(id) {
    if (!window.confirm('Ištrinti įspėjimą?')) return;
    await api.delete(`/alerts/${id}`);
    toast.success('Ištrinta'); loadData();
  }

  async function toggleActive(a) {
    await api.put(`/alerts/${a.id}`, {...a, is_active: !a.is_active});
    loadData();
  }

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div className="page-title">Srauto įspėjimai</div>
          <div className="page-subtitle">Gaukite el. paštą kai srautas viršija nustatytą ribą</div>
        </div>
        <button className="btn btn-primary" onClick={openCreate}>+ Naujas įspėjimas</button>
      </div>

      <div className="card" style={{ marginBottom: 24, background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)' }}>
        <div style={{ display:'flex', gap:12, alignItems:'flex-start' }}>
          <span style={{ fontSize:20 }}>⚠️</span>
          <div style={{ fontSize:13, color:'var(--text-muted)', lineHeight:1.6 }}>
            Įspėjimai tikrinami kas 15 minučių. El. laiškas bus išsiųstas kai pasirinkto objekto skaičius per nurodytą periodą viršys ribą. Po siuntimo veikia atsistatymo laikotarpis (lygus periodui).
          </div>
        </div>
      </div>

      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Pavadinimas</th><th>Objektas</th><th>Riba</th><th>Periodas</th><th>Kamera</th><th>El. paštas</th><th>Paskutinį kartą</th><th>Būsena</th><th>Veiksmai</th></tr></thead>
            <tbody>
              {alerts.map(a => (
                <tr key={a.id}>
                  <td style={{ fontWeight:600 }}>{a.name}</td>
                  <td>{OBJ[a.object_type]}</td>
                  <td><span className="badge badge-warning">≥ {a.threshold}</span></td>
                  <td>{a.period_minutes} min.</td>
                  <td style={{ fontSize:12 }}>{a.camera_name || 'Visos'}</td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{a.notify_email || '—'}</td>
                  <td style={{ fontSize:11, color:'var(--text-muted)' }}>{a.last_triggered ? new Date(a.last_triggered).toLocaleString('lt-LT') : '—'}</td>
                  <td>
                    <div className="cam-status">
                      <div className={`cam-dot ${a.is_active ? 'online' : 'offline'}`} />
                      <button style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-muted)', fontSize:12 }} onClick={() => toggleActive(a)}>
                        {a.is_active ? 'Aktyvus' : 'Išjungtas'}
                      </button>
                    </div>
                  </td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      <button className="btn btn-sm btn-secondary" onClick={() => openEdit(a)}>✏️</button>
                      <button className="btn btn-sm btn-danger"    onClick={() => handleDelete(a.id)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!alerts.length && <tr><td colSpan={9} style={{ textAlign:'center', color:'var(--text-muted)', padding:40 }}>Dar nėra įspėjimų.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">{editId ? 'Redaguoti įspėjimą' : 'Naujas įspėjimas'}</div>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label className="form-label">Pavadinimas *</label>
                <input className="form-input" value={form.name} onChange={e => setForm({...form,name:e.target.value})} required placeholder="pvz. Daug žmonių prie įėjimo" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Objekto tipas</label>
                  <select className="form-input" value={form.object_type} onChange={e => setForm({...form,object_type:e.target.value})}>
                    {Object.entries(OBJ).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Kamera</label>
                  <select className="form-input" value={form.camera_id} onChange={e => setForm({...form,camera_id:e.target.value})}>
                    <option value="">Visos kameros</option>
                    {cameras.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Riba (objektų skaičius) *</label>
                  <input className="form-input" type="number" min="1" value={form.threshold} onChange={e => setForm({...form,threshold:e.target.value})} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Periodas (minutės)</label>
                  <select className="form-input" value={form.period_minutes} onChange={e => setForm({...form,period_minutes:e.target.value})}>
                    <option value="15">15 min</option>
                    <option value="30">30 min</option>
                    <option value="60">1 val.</option>
                    <option value="240">4 val.</option>
                    <option value="1440">1 diena</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Pranešimo el. paštas (tuščia = paskyros el. paštas)</label>
                <input className="form-input" type="email" value={form.notify_email} onChange={e => setForm({...form,notify_email:e.target.value})} placeholder="isp@imone.lt" />
              </div>
              {editId && (
                <label style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', padding:'10px 14px', background:'var(--bg)', borderRadius:8, border:'1px solid var(--border)', marginBottom:12 }}>
                  <input type="checkbox" checked={form.is_active} onChange={e => setForm({...form,is_active:e.target.checked})} style={{ width:16,height:16 }} />
                  <span style={{ fontSize:13, fontWeight:600 }}>✅ Įspėjimas aktyvus</span>
                </label>
              )}
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Atšaukti</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? <span className="loading-spinner" /> : editId ? 'Išsaugoti' : 'Sukurti'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
